interface ChartTooltipProps {
    children: React.ReactNode;
}

const ChartTooltip = ({ children }: ChartTooltipProps) => {
    return (
        <div className="rounded-xs bg-white text-gray-9 p-2 text-sm border border-solid border-gray-4">
            {children}
        </div>
    );
};

export default ChartTooltip;
